// ─── Month / Week / Day ──────────────────────────────────────────────────────
//
// The one navigation control the reference image is explicit about. Rendered
// as real tabs rather than styled divs so keyboard and screen-reader users get
// the behaviour the shape promises.

export const CALENDAR_VIEWS = ["month", "week", "day"] as const;
export type CalendarView = (typeof CALENDAR_VIEWS)[number];

const LABEL: Record<CalendarView, string> = { month: "Month", week: "Week", day: "Day" };

export function CalendarTabs({ view, onChange }: {
  view: CalendarView;
  onChange: (view: CalendarView) => void;
}) {
  return (
    <div
      role="tablist"
      aria-label="Calendar view"
      style={{
        display: "inline-flex", gap: 4, padding: 4,
        background: "var(--nl-surface)",
        border: "1px solid var(--nl-stroke)",
        // Absolute radius: this control is much wider than it is tall, which
        // is precisely the shape a pill radius would ruin.
        borderRadius: "var(--nl-radius-control)",
      }}
    >
      {CALENDAR_VIEWS.map(v => {
        const selected = v === view;
        return (
          <button
            key={v}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(v)}
            style={{
              borderRadius: "var(--nl-radius-chip)",
              border: selected ? "1px solid var(--nl-stroke)" : "1px solid transparent",
              background: selected ? "var(--nl-state-open)" : "transparent",
              color: selected ? "var(--nl-state-open-ink)" : "var(--nl-ink-dim)",
              minHeight: "var(--nl-hit-min)",
              padding: "0 16px", cursor: "pointer", font: "inherit",
            }}
          >{LABEL[v]}</button>
        );
      })}
    </div>
  );
}
